"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFunctionName = getFunctionName;
function getFunctionName(fn) {
    return fn.name || '[anonymous Function]';
}
